import http from './http'

class Campaign {
  get (id) {
    return http.get(`/campaigns/${id}`)
  }

  fetch () {
    return http.get('/campaigns')
  }

  save (payload) {
    return http.post('/campaigns', { campaign: payload })
  }

  update (payload) {
    return http.get(`/campaigns/${payload.id}`, { campaign: payload })
  }

  sendEmail (id) {
    return http.post(`/campaigns/${id}/send_campaign`)
  }

  datasInvoices (payload) {
    return http.post('/campaigns/datas_of_invoices', payload)
  }

  fetchAvailableAssignors (id) {
    return http.get(`/campaigns/assignors/available/${id}`)
  }

  changeStatus (payload) {
    return http.put('/payer_assignors/change_assignor_available_to_campaign_status', payload)
  }

  changeStatusAproveReject (payload) {
    return http.put('/payer_assignors/change_assignor_need_approval_create_assignment_request', payload)
  }
}

export default new Campaign()



// WEBPACK FOOTER //
// ./src/services/campaign.js